<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Offer Group Type</div>
        <div class="section-subTitle my-2"></div>
      </div>
      <div>
        <b-button
          v-if="isEditable && $can('update', 'Offer Group Type')"
          variant="default"
          class="btn-blue"
          @click="() => updateOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else-if="$can('update', 'Offer Group Type')"
          variant="default"
          class="btn-blue"
          @click="() => editOrder()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button
          variant="default"
          to="add-offer-group-type"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getOfferGroupTypes"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status.status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 100px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width:400px">
            <img
              v-if="this.columnName != 'ogt_type_name'"
              @click="onSortValue('ogt_type_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('ogt_type_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('ogt_type_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            Offer group type
          </th>
          <th class="text-center" style="width:100px">Ogt Order</th>
          <th></th>
        </tr>
      </thead>
      <template v-if="offerGroupTypes && offerGroupTypes.length > 0">
        <!-- <tbody> -->
          <draggable
          :list="offerGroupTypes"
          tag="tbody"
          v-bind="dragOptions"
          :move="draggableElements"
          @end="
            endSort($event);
            drag = false;
          "
          @start="drag = true"
        >
          <tr v-for="(item, key) in offerGroupTypes" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.ogt_is_active == 'Y' ? 'active' : 'inactive'"
                />
                <div
                  class="ml-4 clickable-icon"
                  @click="
                    goToRoute(
                      `/marketing/edit-offer-group-type/${item.ogt_id}`,
                      item
                    )
                  "
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
              </div>
            </td>
            <td>{{ item.ogt_type_name }}</td>
            <td class="text-right">{{ item.ogt_order }}</td>
            <td></td>
          </tr>
          </draggable>
        <!-- </tbody> -->
      </template>

      <tbody v-if="offerGroupTypes.length == 0">
        <tr>
          <td colspan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="offerGroupTypes.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import draggable from "vuedraggable";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
    draggable,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      drag: false,
      isEditable: false,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Inactive" },
        { status: "All" },
      ],
      selectedStatus: "Active",
      gridView: false,
      listView: true,
      offerGroupTypes: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "ogt_type_name",
    };
  },
  beforeMount() {
    this.getOfferGroupTypes();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    draggableElements: function () {
      return this.isEditable;
    },
    endSort(event) {
      this.offerGroupTypes.map((x, index) => {
        if (this.currentPage != 1) {
          x.ogt_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.ogt_order = index + 1;
        }
      });
      // console.log("this.sorted Labels", this.Labels);
      // console.log("this.event", event);
    },
    editOrder: function () {
      this.isEditable = true;
      if (this.isEditable) {
        this.filterButtonTitle = "Active";
        this.selectedStatus = "Active";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    updateOrder: function () {
      this.isEditable = false;
      let payload = {
        ms_offer_group_type: this.offerGroupTypes,
      };
      MarketingService.UpdateOfferGroupTypeOrder(payload)
        .then((data) => {
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.getOfferGroupTypes();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getOfferGroupTypes();
      } else {
        this.currentPage = event;
        this.getOfferGroupTypes();
      }
    },
    goToRoute: function (path, item) {
      const { sstg_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: sstg_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getOfferGroupTypes();
    },
    getOfferGroupTypes: function () {
      this.offerGroupTypes = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        status: this.selectedStatus,
      };
      MarketingService.GetAllOfferGroupType(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.offerGroupTypes = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferGroupType/OfferGroupType.vue